import { OnInit, OnDestroy, Component, Optional, Inject } from '@angular/core';
import { IContextService, DomainContext } from '@pershing/pershing-core';
import { Subscription } from 'rxjs';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { NxiWidgetParamsService } from '../../services/NXI-WidgetParams.service';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { NxiContextUtils } from '@pershing/nxi-common';

declare let dojoApp: any;

@Component({
    selector: 'dojo-ugl-summary',
    templateUrl: './dojo-ugl-summary.component.html'
})
export class DojoUglSummaryComponent implements OnInit, OnDestroy {
    inputValue: string = '';
    domain: string = '';
    subs: Subscription;
    acctRef: any;
    appSettings: any;
    realTimeActive: boolean = false;
    constructor(private contextService: IContextService,
                private nxiRestService: NxiRestService,
                private location: Location,
                private nxiWidgetParamsService: NxiWidgetParamsService,
                private route: ActivatedRoute,
                @Optional() @Inject('AppSettings') appSettings: any) {
                    this.appSettings = appSettings;
    }

    ngOnInit() {
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.inputValue = contextValue.inputValue;
            this.acctRef = contextValue.hashValue;
            this.route.queryParams.subscribe(params => {
                if (params.rt) {
                    this.realTimeActive = params.rt;
                }
            });
            this.getUglSummary();
        });
    }

    ngOnDestroy(): void {
        console.log('In dojo UGL Summary destroy method');
        if (this.subs) {
            this.subs.unsubscribe();
        }
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            dojoApp.destroyUglSummary();
        }
    }
    renderDojoWidget(uglSummaryDojoParams: any) {
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            dojoApp.renderUglSummary(this.inputValue, uglSummaryDojoParams);
        }
    }

    getUglSummary() {
        if (this.inputValue && this.acctRef) {
            if (sessionStorage.getItem('realTimeActive') && 'true' === sessionStorage.getItem('realTimeActive')) {
                this.realTimeActive = true;
            } else {
                this.realTimeActive = false;
            }
            this.nxiWidgetParamsService.getWidgetParams(this.acctRef, 'uglSummary?realtimeQuote=' + this.realTimeActive).subscribe(
                resp => {
                    console.log('Retrived common REST Holdings Grid params : ', resp.response);
                    if (resp.response) {
                        resp.response.storeUrl = this.nxiRestService.serviceUrl + resp.response.storeUrl;
                        resp.response.modAPIUrl = this.appSettings.ibdConfigMap.modApiUrl;
                        let queryparam = this.route.snapshot.queryParams;
                        if (queryparam && queryparam.symbol) {
                            resp.response.symbol = decodeURIComponent(queryparam.symbol);
                        }
                        resp.response.isDelayedQuote = resp.response.delayedQuote;
                        this.renderDojoWidget(resp.response);
                    }
                }
            );
        }
    }
}
